// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__3Tq5D","label":"LabeledBox_label__28zQy"};